import React, { use, useEffect, useState } from "react";
import SecondaryButton from "../buttons/SecondaryButton.js";

import Modal1 from "../modals/Modal1.js";

import PDF from "../pdf/PDF.js";
import downloadFile from "../api/download/downloadFile.js";
import getTemporaryUrl from "../api/getTemporaryUrl.js";
import SmallSpinner from "../loading/SmallSpinner.js";
import { getOrRefreshFirebaseToken } from "../config/getFirebaseToken.js";
import { getDocDataById, getDocDataByRef } from "../models/DataFunctions.js";
import { generateKey } from "../portal/InvoiceSign.js";

const FacturePaymentVisualisateur = ({
  folder,
  orgData,
  payment_id,
  prefix,
}) => {
  const [open, setOpen] = useState(false);
  const [file, setFile] = useState(null);
  const [loadingFile, setLoadingFile] = useState(false);
  const [paymentData, setPaymentData] = useState(null);

  const handleLoadUrl = async (spin = false) => {
    spin && setLoadingFile(paymentData?.facture_file?.name);

    const token = await getOrRefreshFirebaseToken();
    await getTemporaryUrl(token, "facture", "", folder.id, prefix);
    let folderData = await getDocDataByRef(folder.ref);
    let paymentDatae = await getDocDataById("payment", payment_id);
    setPaymentData(paymentDatae);
    let file = paymentDatae?.facture_file;
    if (file) window.open(file.url, "_blank");
    setLoadingFile(null);
  };

  const handleFetchData = async () => {
    let paymentDatae = await getDocDataById("payment", payment_id);
    setPaymentData(paymentDatae);
    let file = paymentDatae?.facture_file;
    if (file) setFile(file);
  };

  useEffect(() => {
    if (folder && payment_id) {
      handleFetchData();
    }
  }, [folder, payment_id]);

  const handleDownload = async () => {
    await handleLoadUrl(true);
    downloadFile(
      paymentData?.facture_file,
      "Facture_" + folder.nom.replace(/ /g, "_") + ".pdf"
    );
  };

  return (
    <div className="flex gap-2 h-full ">
      {open && paymentData?.facture_file && (
        <Modal1 isOpen={open} onClose={() => setOpen(false)}>
          <div className="flex flex-col max-w-c900 w-full h-fit bg-neutral-100 rounded-md">
            <PDF files={[file]} onClose={() => setOpen(false)}></PDF>
          </div>
        </Modal1>
      )}
      <SecondaryButton
        disabled={!paymentData?.facture_file}
        onClick={() => {
          handleLoadUrl(true);
          setOpen(true);
        }}
        className="w-fit h-fit gap-2"
      >
        Voir
        <SmallSpinner
          loading={loadingFile === paymentData?.facture_file?.name}
        />
      </SecondaryButton>{" "}
      <SecondaryButton
        disabled={!paymentData?.facture_file}
        onClick={() => handleDownload()}
        className="w-fit h-fit"
      >
        Télécharger
      </SecondaryButton>{" "}
    </div>
  );
};

export default FacturePaymentVisualisateur;
